const getters = {
  jobLevelList: state => state.staff.jobLevelList
}
export default getters
